var map = {
	"./ahri.png": 67,
	"./annie.png": 68,
	"./ashe.png": 69,
	"./aurelionsol.png": 70,
	"./blitzcrank.png": 71,
	"./caitlyn.png": 72,
	"./chogath.png": 73,
	"./darius.png": 74,
	"./ekko.png": 75,
	"./ezreal.png": 76,
	"./fiora.png": 77,
	"./fizz.png": 78,
	"./gangplank.png": 79,
	"./garen.png": 80,
	"./graves.png": 81,
	"./irelia.png": 82,
	"./jarvaniv.png": 83,
	"./jayce.png": 84,
	"./jhin.png": 85,
	"./jinx.png": 86,
	"./kaisa.png": 87,
	"./karma.png": 88,
	"./kassadin.png": 89,
	"./kayle.png": 90,
	"./khazix.png": 91,
	"./leona.png": 92,
	"./lucian.png": 93,
	"./lulu.png": 94,
	"./lux.png": 95,
	"./malphite.png": 96,
	"./masteryi.png": 97,
	"./missfortune.png": 98,
	"./mordekaiser.png": 99,
	"./neeko.png": 100,
	"./poppy.png": 101,
	"./rakan.png": 102,
	"./rumble.png": 103,
	"./shaco.png": 104,
	"./shen.png": 105,
	"./sona.png": 106,
	"./soraka.png": 107,
	"./syndra.png": 108,
	"./thresh.png": 109,
	"./twistedfate.png": 110,
	"./velkoz.png": 111,
	"./vi.png": 112,
	"./wukong.png": 113,
	"./xayah.png": 114,
	"./xerath.png": 115,
	"./xinzhao.png": 116,
	"./yasuo.png": 117,
	"./ziggs.png": 118,
	"./zoe.png": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;